export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1000px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-600 via-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              移动客户端
            </h2>
            <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-6">
              91在线视频移动客户端专为手机和平板优化，提供更流畅的<strong className="text-background-50">91精品视频在线播放</strong>体验。
              支持离线缓存、夜间模式、个性化推荐等功能，让您随时随地畅享<strong className="text-background-50">精品影视</strong>与<strong className="text-background-50">高分电影</strong>。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 font-medium rounded-full text-sm hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-line"></i>
                Android 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 text-background-50 font-medium rounded-full text-sm hover:bg-background-50/30 transition-colors duration-200 border border-background-50/30 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-line"></i>
                iOS 下载
              </a>
            </div>
          </div>

          <div className="flex-shrink-0 w-48 md:w-56">
            <div className="aspect-[9/16] rounded-2xl overflow-hidden bg-background-50/20 border border-background-50/20">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20mobile%20app%20interface%20mockup%20for%20a%20premium%20video%20streaming%20platform%2C%20showing%20movie%20thumbnails%20in%20a%20dark%20theme%20with%20warm%20coral%20accents%2C%20clean%20card%20layout%20with%20film%20posters%2C%20elegant%20typography%2C%20smooth%20gradient%20background%2C%20modern%20minimal%20design&width=448&height=796&seq=app-mockup-91&orientation=portrait"
                alt="91在线视频移动客户端界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}